import { getServicability } from '@api/store';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from '@chakra-ui/react';
import { Container, Navbar } from '@components';
import { TIdentity, TVisitor } from '@components/types';
import { cartState, isLoggedIn } from '@recoil/atoms';
import dynamic from 'next/dynamic';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';

const Header = dynamic(
  () => import('../../src/components/header').then((mod) => mod.Header),
  {
    ssr: false,
  }
);

const CartInfo = dynamic(
  () => import('../../src/components/cartinfo').then((mod) => mod.CartInfo),
  {
    ssr: false,
  }
);

const CartDetails = dynamic(
  () =>
    import('../../src/components/cartinfo/summary').then(
      (mod) => mod.CartDetails
    ),
  {
    ssr: false,
  }
);

function Cart() {
  const [profile, setProfile] = useState<TIdentity>(null);
  const isLogin = useRecoilValue(isLoggedIn);
  const cart = useRecoilValue(cartState);
  const cartValues = Array.from(cart.values());
  const [visitorInfo, setVisitorInfo] = useState<TVisitor | null>(null);
  const [tableInfo, setTableInfo] = useState(null);
  const [dineinOrTakeaway, setDineinOrTakeaway] = useState(null);
  const [isDelivery, setIsDelivery] = useState(false);

  const router = useRouter();

  const onDineinOrTakeaway = (value: string) => {
    setDineinOrTakeaway(value);
    sessionStorage.setItem(
      'tableInfo',
      JSON.stringify({
        source: tableInfo?.source,
        table: tableInfo?.table,
        table_id: tableInfo?.table_id,
        is_ac: tableInfo?.is_ac,
        dineinOrTakeaway: value,
        timeStamp: Date.now(),
      })
    );
  };

  function onProceed() {
    let productIds = cartValues?.map((item) => (item?.inventory?.id))
    let productContents = cartValues?.map((item) => ({ id: item?.inventory?.id, quantity: item?.quantity }))
    if (tableInfo) {
      if (dineinOrTakeaway === 'DINEIN') {
        router.push('/cart/paymentmethod');
      } else if (dineinOrTakeaway === 'TAKEAWAY') {
        router.push('/cart/paymentmethod');
      }
    } else if (isDelivery) router.push('/cart/selectaddress');
    else router.push('/cart/paymentmethod');
    window?.fbq('track', 'InitiateCheckout', {
      content_ids: productIds,
      contents: productContents,
      num_items: cartValues?.length,
    });
  }

  useEffect(() => {
    if (window && localStorage.getItem('profile')) {
      setProfile(JSON.parse(localStorage.getItem('profile')));
    }

    if (window && localStorage.getItem('visitorInfo')) {
      setVisitorInfo(JSON.parse(localStorage.getItem('visitorInfo')));
    }

    if (window && sessionStorage.getItem('tableInfo')) {
      setTableInfo(JSON.parse(sessionStorage.getItem('tableInfo')));
      setDineinOrTakeaway('DINEIN');
    }
  }, []);

  

  return (
    <Container>
      <Header />
      <div className="max-w-[1240px] font-monrope mx-auto w-full pb-20">
        <div className="px-2 hidden md:flex py-8">
          <Breadcrumb className="text-base text-neutral-400 font-medium list-none text-breadcrumbs py-4 ">
            <BreadcrumbItem>
              <BreadcrumbLink href="/">Home</BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbItem
              className="text-ellipsis text-left break-words line-clamp-1 select-none text-neutral-800 font-semibold"
              isCurrentPage
            >
              <BreadcrumbLink href={`/cart`}>Cart</BreadcrumbLink>
              <ol className="p-0 list-none"></ol>
            </BreadcrumbItem>
          </Breadcrumb>
        </div>

        <div className="md:block hidden w-full">
          <h1 className="font-bold text-lg px-2 text-neutral-900 font-manrope">
            Cart
          </h1>
        </div>
        <div className="h-4 md:block hidden"></div>
        {tableInfo?.table !== null && tableInfo?.table !== undefined && (
          <div className="p-2 flex gap-10 items-center">
            <div className="flex gap-2 items-center">
              <input
                title="DINEIN"
                name="DineinAndTakeaway"
                type="radio"
                value="DINEIN"
                onChange={(e) => {
                  onDineinOrTakeaway(e.target.value);
                }}
                checked={dineinOrTakeaway == 'DINEIN'}
              />
              <label
                htmlFor="DINEIN"
                className="font-bold font-sm text-bannerText"
              >
                DINE IN
              </label>
            </div>
            <div className="flex gap-2 items-center">
              <input
                title="TAKEAWAY"
                name="DineinAndTakeaway"
                type="radio"
                value="TAKEAWAY"
                onChange={(e) => {
                  onDineinOrTakeaway(e?.target?.value);
                }}
                checked={dineinOrTakeaway == 'TAKEAWAY'}
              />
              <label
                htmlFor="TAKEAWAY"
                className="font-bold font-sm text-bannerText"
              >
                TAKEAWAY
              </label>
            </div>
          </div>
        )}

        <div className="flex md:flex-row grow justify-between gap-4 flex-col px-2 ">
          <div className="flex flex-1 flex-col gap-4">
            {(visitorInfo || profile) && !tableInfo && cart?.size > 0 && (
              <div className="p-4 rounded-lg border border-solid border-neutral-200 bg-neutral-50">
                <div className="flex justify-between items-center">
                  <div className="space-y-2">
                    <span className="text-sm text-neutral-800 font-medium">
                      {profile ? 'Deliver To :' : 'Billing Info :'}
                    </span>
                    <p className="text-sm text-neutral-800 font-medium">
                      <span className="text-neutral-600">Full Name :</span>{' '}
                      {profile?.full_name
                        ? profile?.full_name
                        : visitorInfo?.name}
                    </p>
                    <p className="text-sm text-neutral-800 font-medium">
                      <span className="text-neutral-600">Phone :</span>{' '}
                      {profile?.full_name ? profile?.phone : visitorInfo?.phone}
                    </p>
                  </div>
                  <Link
                    href={isLogin ? '/account/profile' : '/cart/nonloggeduser'}
                  >
                    <button
                      type="button"
                      className="text-sm text-brand-500 font-manrope font-bold cursor-pointer"
                    >
                      Edit Info
                    </button>
                  </Link>
                </div>
              </div>
            )}
            <CartInfo noLink={true} setIsDelivery={setIsDelivery}/>
          </div>
          <div className="md:w-[50%] h-max sticky top-2">
            {cart?.size > 0 && (
              <CartDetails actionFun={onProceed} btnName="PROCEED TO BUY" isShowTaxes={true} />
            )}
          </div>
        </div>
        <Navbar />
      </div>
    </Container>
  );
}
export default Cart;
